const TableTitleService = {
  title: 'Servicios',
  placeholder: 'Buscar',
  Typography: 'Ningún resultado encontrado'
};

export default TableTitleService;
